//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation,useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';
// import { useLocation, useHistory } from "react-router-dom";

// custom pages
import Logo from "assets/img/consent-logo.png";

import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import { imageHandler } from "helpers/imageHandler";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";


// material-ui icons

export default function GepResponse() {

  const classes = consentStyles();
  const location = useLocation();

  const param = new URLSearchParams(location.search);
  const getmessage = decodeURIComponent(param.get("message"));
  // const getmessage = 'Thank you for your interest in the Henry Schein Thrive Rewards program. The network seems to be unstable. If the problem persists, please call our Thrive Rewards Customer Service at 1-800-888-6684 (8 AM-8 PM EST Monday-Friday). Error Code - 013 GEP';


  // const formattedMessage = getmessage.replace(
  //   /(Error Code\s*-\s*\d+)/gi,
  //   '<strong style="font-size: 1em; color: red;">$1</strong>'
  // );
  const database = decodeURIComponent(param.get("database"));
  let db = database?database:'US'



  const history = useHistory();

  const { t } = useTranslation();



  return (
    <div className={classes.mainDiv}>
     
     {db && (
  <img
    src={
      imageHandler?.[db === "US" ? "Henry Schein Dental" : "Henry Schein Canada"]
        ?. [i18n?.language]
        ?. [db === "US" ? "Newheader" : "nullHeaderLogo"]
    }
    alt="logo"
    style={{ marginTop: 50, marginBottom: 50, width: 400 }}
  />
)}
          <Card className={classes.gepcard}>
            <div className={classes.divText}>{t("Notice to user")}</div>
            <div className={classes.divSubText}>
              {
                getmessage
              }
                       
              
            </div>
            {/* <Button
              className={classes.gepcancelBtn}
              onClick={() => {
                
             
              }}
            > */}
                <div className={classes.gepcancelBtn}>
                {t("Close Tab")}
                </div>
            {/* </Button> */}
            
          </Card>
       
          </div>
  );
}
